/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { themeColors } from './Constants';

type Props = {
  children?: React.ReactNode;
  detailView: React.ReactNode;
};

class MasterDetailView extends Component<Props> {
  render() {
    return (
      <View style={styles.root}>
        <View style={styles.masterWrapper}>{this.props.children}</View>
        <View style={styles.detailView}>{this.props.detailView}</View>
      </View>
    );
  }
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: themeColors.backgroundGrey,
  },
  masterWrapper: {
    flex: 1,
    marginRight: 20,
    backgroundColor: themeColors.white,
    borderColor: themeColors.grey,
  },
  detailView: {
    width: '30%',
    // This is so that ContentElement will be able to fit the Editor
    // TODO: Find a better solution
    minWidth: 430,
    backgroundColor: themeColors.backgroundGrey,
  },
});

export default MasterDetailView;
